<!-- <h4 color="primary" class="dialog-headline"><p>Create user</p></h4> -->
<div class="mdc-dialog__surface">
  <div class="dialog-headline">
    <mat-label style="float:left;">{{receivedData.headerTitle}}</mat-label>
    <mat-icon *ngIf="!changePasswordAtLogin" class="pointer" matTooltip="Close this dialog" mat-dialog-close
      style="float: right;">close</mat-icon>
  </div>
  <!-- <h2 mat-dialog-title style="background-color: rgb(38, 142, 226);">Install Angular</h2> -->
  <mat-dialog-content class="mat-typography" style="padding-top: 20px;">

    <!-- user form taking values -->

    <form #changePasswordModalForm="ngForm" autocomplete="off">

      <div fxLayout="row wrap">
        <div fxFlex.gt-lg="100" fxFlex.gt-md="100" fxFlex.gt-xs="100" fxFlex="100">

          <mat-form-field>
            <mat-label>User Name</mat-label>
            <input matInput name="userName" #userName="ngModel" id="userName" [(ngModel)]="userData.userName" required
              readonly>
          </mat-form-field>

        </div>
      </div>
      <br>
      <div fxLayout="row wrap">
        <div fxFlex.gt-lg="100" fxFlex.gt-md="100" fxFlex.gt-xs="100" fxFlex="100">
          <mat-form-field>
            <mat-label>Old Password</mat-label>
            <input matInput name="oldPassword" #oldPassword="ngModel" id="oldPassword"
              [(ngModel)]="userData.oldPassword" required [type]="hideOldPwd ? 'password' : 'text'">
            <mat-icon class="pointer" matSuffix (click)="hideOldPwd = !hideOldPwd">{{hideOldPwd ?
              'visibility_off' :
              'visibility'}}
            </mat-icon>

            <mat-error *ngIf="oldPassword.invalid && (oldPassword.dirty || oldPassword.touched)"
              class="invalid-feedback">
              Please enter old password
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <br>

      <div fxLayout="row wrap">
        <div fxFlex.gt-lg="100" fxFlex.gt-md="100" fxFlex.gt-xs="100" fxFlex="100">
          <mat-form-field>
            <mat-label>New Password</mat-label>
            <input matInput name="newPassword" #newPassword="ngModel" id="newPassword"
              (input)="onPasswordChange(newPassword.value)" [(ngModel)]="userData.newPassword" required
              [type]="hideNewPwd ? 'password' : 'text'">
            <mat-icon class="pointer" matSuffix (click)="hideNewPwd = !hideNewPwd">{{hideNewPwd ?
              'visibility_off' :
              'visibility'}}
            </mat-icon>

            <mat-error *ngIf="newPassword.invalid && (newPassword.dirty || newPassword.touched)"
              class="invalid-feedback">
              Please enter new password
            </mat-error>
          </mat-form-field>

          <!-- Custom Password Strength Meter -->
          <div class="password-strength-meter">
            <div class="strength-bar" [ngClass]="strengthClass"></div>
          </div>

          <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
              [hideToggle]="showError" class="no-padding-panel">
              <mat-expansion-panel-header>
                <mat-panel-description class="expansion-header">
                  <mat-icon *ngIf="!panelOpenState">arrow_forward</mat-icon>
                  <mat-icon *ngIf="panelOpenState">arrow_downward</mat-icon>
                  Expand to see errors
                </mat-panel-description>
              </mat-expansion-panel-header>

              <!-- Custom Password Strength Info -->
              <div class="password-strength-info">
                <div class="strength-feedback">
                  <mat-icon [color]="strengthColor">{{strengthIcon}}</mat-icon>
                  <span>{{strengthMessage}}</span>
                </div>

                <ul class="password-requirements">
                  <li [class.requirement-met]="hasMinLength">
                    <mat-icon>{{ hasMinLength ? 'check_circle' : 'cancel' }}</mat-icon>
                    Contains at least 8 characters
                  </li>
                  <li [class.requirement-met]="hasUpperCase">
                    <mat-icon>{{ hasUpperCase ? 'check_circle' : 'cancel' }}</mat-icon>
                    Contains at least one uppercase letter
                  </li>
                  <li [class.requirement-met]="hasLowerCase">
                    <mat-icon>{{ hasLowerCase ? 'check_circle' : 'cancel' }}</mat-icon>
                    Contains at least one lowercase letter
                  </li>
                  <li [class.requirement-met]="hasNumber">
                    <mat-icon>{{ hasNumber ? 'check_circle' : 'cancel' }}</mat-icon>
                    Contains at least one number
                  </li>
                  <li [class.requirement-met]="hasSpecialChar">
                    <mat-icon>{{ hasSpecialChar ? 'check_circle' : 'cancel' }}</mat-icon>
                    Contains at least one special character
                  </li>
                </ul>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>

      <br>

      <div fxLayout="row wrap">
        <div fxFlex.gt-lg="100" fxFlex.gt-md="100" fxFlex.gt-xs="100" fxFlex="100">
          <mat-form-field>
            <mat-label>Confirm Password</mat-label>
            <input matInput name="confirmPassword" #confirmPassword="ngModel" id="confirmPassword"
              [(ngModel)]="userData.confirmPassword" required [type]="hideConfirmPwd ? 'password' : 'text'">
            <mat-icon class="pointer" matSuffix (click)="hideConfirmPwd = !hideConfirmPwd">{{hideConfirmPwd ?
              'visibility_off' :
              'visibility'}}
            </mat-icon>


            <mat-error *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)"
              class="invalid-feedback">
              Please enter confirm password
            </mat-error>

            <mat-error *ngIf="(userData.confirmPassword!=userData.password)" class="invalid-feedback">
              Confirm password does not match with password
            </mat-error>
          </mat-form-field>

        </div>
      </div>

    </form>
    <br>


  </mat-dialog-content>
  <!-- for adding line -->
  <hr>
  <mat-dialog-actions align="end">
    <button *ngIf="!changePasswordAtLogin" mat-dialog-close class="custom-grey-button" matTooltip="Close this dialog">
      <mat-icon>close</mat-icon>Close
    </button>

    <button *ngIf="!changePasswordAtLogin" class="custom-orange-button"
      [disabled]="changePasswordModalForm.invalid || !(isPasswordStrong && userData.confirmPassword==userData.newPassword)"
      (click)="changeUserPassword();" cdkFocusInitial matTooltip="Change Password">
      Change Password
    </button>

    <button *ngIf="changePasswordAtLogin" class="custom-orange-button"
      [disabled]="changePasswordModalForm.invalid || !(isPasswordStrong && userData.confirmPassword==userData.newPassword)"
      (click)="changeUserPasswordAtLogin();" cdkFocusInitial matTooltip="Change Password">
      Change Password
    </button>

  </mat-dialog-actions>
</div>
